import { Viewer } from "@react-pdf-viewer/core";

import { SquareArrowOptUpRight } from "../../Assets/Icons";

import "./esign-disclosure-viewer.scss";

export const ESIGN_DISCLOSURE_PDF_URL =
  "https://stake-platform-s3.s3.us-east-1.amazonaws.com/terms/esign-consent.pdf";

export default function EsignDisclosureViewer({ fileUrl = ESIGN_DISCLOSURE_PDF_URL, onPageChange }) {
  const handleOpenInNewTab = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="esign-disclosure-box">
      <div className="esign-disclosure-toolbar">
        <button
          type="button"
          className="esign-disclosure-expand-btn"
          onClick={handleOpenInNewTab}
          aria-label="Open E-Sign Consent Disclosure in a new tab"
        >
          <SquareArrowOptUpRight />
          Open in new tab
        </button>
      </div>
      <div className="esign-disclosure-viewer">
        <Viewer fileUrl={fileUrl} onPageChange={onPageChange} />
      </div>
    </div>
  );
}
